import { useState, useEffect } from "react";
import { getShiftsAPI } from "../services/shifts";
import moment from "moment";

function UseEmpsShifts() {
  const [data, setData] = useState([]);
  useEffect(() => {
    const getData = async () => {
      const result = await getShiftsAPI();
      if (!result) return;
      const newData = result.result.map((d, i) => {
        let label;

        if (d.shift && d.shift.trim().toUpperCase().startsWith('O' && 'S')) {
          label = {
            value: d.id,
            label: d.shift,
          };
        } else {
          label = {
            value: d.id,
            label: `${d.shift}`
            //  ${
            //   d?.start_time
            //     ? moment(d.start_time, "HH:mm:ss").format("HH:mm")
            //     : ""
            // } - ${
            //   d.end_time
            //     ? moment(d.end_time, "HH:mm:ss").format("HH:mm")
            //     : ""
            // }`,
          };
        }
      
        return label;
      })
      
      // const newData = result.result.map((d, i) => {
      //   return {
      //     value: d.id,
      //     label: `${d.shift} ${
      //       d?.start_time
      //         ? moment(d.start_time, "HH:mm:ss").format("HH:mm")
      //         : ""
      //     }
      //     -
      //     ${
      //       d.end_time
      //       ? moment(d.end_time, "HH:mm:ss").format("HH:mm")
      //     : ""}`,
      //   };
      // });

      setData(newData);
    };
    getData();
  }, []);

  return data;
}

export default UseEmpsShifts;
